import {
  createRouter, createWebHistory,
} from 'vue-router';

import {
  routes,
} from './routes';

import {
  keycloakAuthenticationHandler,
} from '@/authentication.ts';

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

// Ensures that the user is still authenticated. Will also handle token refresh
keycloakAuthenticationHandler.addRouterMiddleware(router);

export default router;
